var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Heart","d":"M17.637,1.555a5.143,5.143,0,0,0-7.321,0l-.72.72-.72-.72A5.177,5.177,0,0,0,1.555,8.876L9.6,16.917l8.041-8.041a5.143,5.143,0,0,0,0-7.321","transform":"translate(0.975 0.975)"}));
}

Heart.defaultProps = {"width":"21.142","height":"19.306","viewBox":"0 0 21.142 19.306"};

module.exports = Heart;

Heart.default = Heart;
